import { render, staticRenderFns } from "./InvitesMemberByEmailPage.vue?vue&type=template&id=21929703"
import script from "./InvitesMemberByEmailPage.vue?vue&type=script&lang=js"
export * from "./InvitesMemberByEmailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports